import * as R from "ramda";
import React from "react";
import "flatpickr/dist/themes/airbnb.css";

import { noop } from "utils/General";

import { DateTimeInputWithoutSagas } from "ui-kit/Form/View";
import CSSModules from "react-css-modules";
import css from "./styles.scss";
import { Text1 } from "components/Base";
import { setOtherZone, setLocalZone } from "utils/General";
import moment from "moment";

const decorate = CSSModules(css);

export const DateTimeInput = ({
  onChange = noop,
  value = "",
  timezone = null,
  eventTimezone = null,
  disabled = false
}) => (
  <div>
    <DateTimeInputWithoutSagas
      value={
        value
          ? setLocalZone(
              R.path(["value", "iso"], value),
              timezone || eventTimezone
            )
          : null
      }
      onChange={val => {
        const otherZoneValue = moment(
          setOtherZone(val, timezone || eventTimezone)
        );
        onChange({
          type: "datetime",
          value: {
            iso: otherZoneValue.toISOString(),
            offset: otherZoneValue.utcOffset()
          }
        });
      }}
      style={{ backgroundColor: "white" }}
      modalVariant
      useHelperText
      disabled={disabled}
    />
    {(timezone || eventTimezone) && (
      <Text1 color="gray6">Event Timezone: {timezone || eventTimezone}</Text1>
    )}
  </div>
);

export default decorate(DateTimeInput);
